// ProjectsPage component - Converted from pages/projects.vue
// Uses shared project listing component instead of a simple placeholder
import React from 'react';
import HeaderOne from '../components/HeaderOne';
import RecentProject from '../components/RecentProject';
import Footer from '../components/Footer';
import PageHeader from '../../components/PageHeader.jsx';

const ProjectsPage: React.FC = () => {
  React.useEffect(() => {
  }, []);

  return (
    <>
      <HeaderOne />
      <PageHeader title="Projets" />
      {/* Reusing home project slider as the projects listing */}
      <RecentProject />
      <Footer />
    </>
  );
};

export default ProjectsPage;
